/** Chat SSE event contract (SSE-over-fetch). */
export const SSE_EVENTS = ["meta", "status", "token", "citations", "action", "revise", "done", "error"] as const;
export type SseEventName = (typeof SSE_EVENTS)[number];

const SSE_EVENT_SET: ReadonlySet<string> = new Set(SSE_EVENTS);

export function isSseEventName(value: string): value is SseEventName {
  return SSE_EVENT_SET.has(value);
}

export const SSE_LAST_EVENT_ID_HEADER = "Last-Event-ID";
/** Terminal events end a stream; the client stops reading after one. */
export const SSE_TERMINAL_EVENTS: readonly SseEventName[] = ["done", "error"];
